// Mock data for HRCPC Legal Cell App
// Will be replaced by MongoDB / FastAPI endpoints in Phase 2

export const MOCK_DISCLAIMER = "Any output is partially or fully AI generated. This is general information only and does not constitute legal advice. Please contact your family Advocate before implementing any suggestion — he is your best friend and advisor who knows your issues very well. HRCPC Trust or its Legal Team is not responsible in any way, as we only have partial information from the client and no detailed consultation has taken place for near-perfect document drafting or advice.";

export const MOCK_CLIENTS = [
  {
    id: "cli_001",
    unique_code: "HRCPC-C-20260301-101",
    full_name: "Rajesh Kumar Sharma",
    mobile: "9876543210",
    email: "rajesh.sharma@gmail.com",
    aadhaar_last4: "4321",
    address: "Flat 402, Sai Towers, Ameerpet",
    city: "Hyderabad",
    state: "Telangana",
    pincode: "500016",
    status: "Approved",
    purpose: "Consumer Dispute against builder for delay in possession",
    preferred_language: "Telugu / Hindi",
    created_at: "2026-03-01"
  },
  {
    id: "cli_002",
    unique_code: "HRCPC-C-20260305-102",
    full_name: "Sunita Reddy",
    mobile: "9123456780",
    email: "sunita.reddy@yahoo.com",
    aadhaar_last4: "8890",
    address: "Road No. 12, Banjara Hills",
    city: "Hyderabad",
    state: "Telangana",
    pincode: "500034",
    status: "Approved",
    purpose: "Family Property Partition & Maintenance Case",
    preferred_language: "Telugu",
    created_at: "2026-03-05"
  },
  {
    id: "cli_003",
    unique_code: "HRCPC-C-20260310-103",
    full_name: "Mohammed Abdul Rahman",
    mobile: "9988776655",
    email: "rahman.abdul@outlook.com",
    aadhaar_last4: "1122",
    address: "Near Charminar, Old City",
    city: "Hyderabad",
    state: "Telangana",
    pincode: "500002",
    status: "Under Review",
    purpose: "Wrongful Employment Termination & Gratuity Claim",
    preferred_language: "Urdu / English",
    created_at: "2026-03-10"
  }
];

export const MOCK_CASES = [
  {
    id: "case_001",
    case_number: "CC/412/2025",
    client_id: "cli_001",
    client_name: "Rajesh Kumar Sharma",
    client_mobile: "9876543210",
    court: "District Consumer Disputes Redressal Commission-I, Hyderabad",
    title: "Sharma vs Vertex Constructions (Apartment Delay Compensation)",
    status: "Arguments & Written Submission",
    next_hearing_date: "2026-04-18",
    assigned_advocates: ["Adv. K. Srinivasa Rao", "Adv. Priya Sharma"],
    total_fee: 25000,
    fee_paid: 15000,
    balance: 10000,
    payment_history: [
      { id: "pay_1", date: "2026-03-02", amount: 10000, mode: "Razorpay UPI", receipt_no: "RCP-2026-001" },
      { id: "pay_2", date: "2026-03-15", amount: 5000, mode: "Razorpay QR", receipt_no: "RCP-2026-014" }
    ],
    documents: [
      { id: "doc_1", name: "Builder_Agreement_Copy.pdf", type: "PDF", date: "2026-03-01", uploaded_by: "Client" },
      { id: "doc_2", name: "Legal_Notice_And_Reply.pdf", type: "PDF", date: "2026-03-10", uploaded_by: "Advocate" },
      { id: "doc_3", name: "Consumer_Complaint_Draft_Final.pdf", type: "PDF", date: "2026-03-18", uploaded_by: "Advocate" }
    ],
    notes: [
      { id: "note_1", date: "2026-03-18", author: "Adv. K. Srinivasa Rao", text: "Builder counsel requested 2 weeks time for counter affidavit. Court granted final opportunity till 18th April." },
      { id: "note_2", date: "2026-03-05", author: "Admin", text: "KYC approved and case registered under Consumer Protection Act 2019." }
    ]
  },
  {
    id: "case_002",
    case_number: "OS/89/2025",
    client_id: "cli_001",
    client_name: "Rajesh Kumar Sharma",
    client_mobile: "9876543210",
    court: "City Civil Court, Hyderabad",
    title: "Sharma vs Municipal Corporation (Encroachment Dispute)",
    status: "Evidence Stage - PW1 Cross Examination",
    next_hearing_date: "2026-04-22",
    assigned_advocates: ["Adv. M. V. Ramana"],
    total_fee: 35000,
    fee_paid: 20000,
    balance: 15000,
    payment_history: [
      { id: "pay_3", date: "2026-03-03", amount: 20000, mode: "Bank Transfer", receipt_no: "RCP-2026-003" }
    ],
    documents: [
      { id: "doc_4", name: "Property_Title_Deed.pdf", type: "PDF", date: "2026-03-03", uploaded_by: "Client" }
    ],
    notes: [
      { id: "note_3", date: "2026-03-20", author: "Adv. M. V. Ramana", text: "Chief examination affidavit filed. Cross-examination deferred to April 22." }
    ]
  },
  {
    id: "case_003",
    case_number: "FC/230/2026",
    client_id: "cli_002",
    client_name: "Sunita Reddy",
    client_mobile: "9123456780",
    court: "Family Court, City Civil Courts Complex, Hyderabad",
    title: "Sunita Reddy vs V. Rajesh Reddy (Maintenance & Settlement)",
    status: "Counseling & Mediation Stage",
    next_hearing_date: "2026-04-12",
    assigned_advocates: ["Adv. Priya Sharma"],
    total_fee: 20000,
    fee_paid: 10000,
    balance: 10000,
    payment_history: [
      { id: "pay_4", date: "2026-03-06", amount: 10000, mode: "Razorpay", receipt_no: "RCP-2026-008" }
    ],
    documents: [
      { id: "doc_5", name: "Marriage_Certificate_And_Petition.pdf", type: "PDF", date: "2026-03-05", uploaded_by: "Client" }
    ],
    notes: [
      { id: "note_4", date: "2026-03-22", author: "Adv. Priya Sharma", text: "Referred to Mediation Center. Both parties attended initial counseling session." }
    ]
  }
];

export const MOCK_ADVOCATES = [
  { id: "adv_1", name: "Adv. K. Srinivasa Rao", role: "Senior Panel Counsel", phone: "9848012345", email: "rao.advocate@hrcpc.org", specialization: "Civil & Consumer Law", active_cases: 12 },
  { id: "adv_2", name: "Adv. Priya Sharma", role: "Family & Human Rights Counsel", phone: "9848054321", email: "priya.sharma@hrcpc.org", specialization: "Family Law & Criminal Defense", active_cases: 9 },
  { id: "adv_3", name: "Adv. M. V. Ramana", role: "High Court Collaborating Counsel", phone: "9848098765", email: "ramana.hc@hrcpc.org", specialization: "Constitutional & Property Writ", active_cases: 15 }
];

export const MOCK_TEMPLATES = [
  { id: "tpl_1", title: "General Promissory Note (Money Lending / Debt)", category: "Financial & Debt", price: 0, file_url: "#", is_free: true, downloads: 1420 },
  { id: "tpl_2", title: "Residential Rental Agreement (11-Month Telangana Format)", category: "Property & Tenancy", price: 99, file_url: "#", is_free: false, downloads: 890 },
  { id: "tpl_3", title: "Right to Information (RTI) Application Format to Public Authority", category: "Govt & Transparency", price: 0, file_url: "#", is_free: true, downloads: 3410 },
  { id: "tpl_4", title: "Consumer Complaint Notice for Defective Goods / Services", category: "Consumer Rights", price: 149, file_url: "#", is_free: false, downloads: 620 },
  { id: "tpl_5", title: "Legal Notice for Recovery of Dues & Unpaid Salary", category: "Employment & Labor", price: 199, file_url: "#", is_free: false, downloads: 410 },
  { id: "tpl_6", title: "Police Complaint Intimation Letter (Cyber Fraud / Cheating)", category: "Criminal & Cyber", price: 0, file_url: "#", is_free: true, downloads: 2150 }
];

export const MOCK_NOTIFICATIONS = [
  { id: "notif_1", client_mobile: "9876543210", title: "Hearing Reminder", message: "Your case CC/412/2025 has next hearing on 18th Apr 2026 at District Consumer Forum-I.", date: "2026-03-25", read: false },
  { id: "notif_2", client_mobile: "9876543210", title: "Fee Balance Reminder", message: "Pending balance of ₹10,000 for CC/412/2025. Click here to pay via Razorpay.", date: "2026-03-24", read: true },
  { id: "notif_3", client_mobile: "9123456780", title: "New Document Uploaded", message: "Adv. Priya Sharma uploaded 'Mediation_Status_Report.pdf' to your case.", date: "2026-03-22", read: false }
];
